export const IconDiamond = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_3830_9686)">
        <path
          d="M12.16 3H11.84L9.21002 8.25H14.79L12.16 3Z"
          fill="currentColor"
        />
        <path
          d="M16.46 8.25H21.62L19 3H13.84L16.46 8.25Z"
          fill="currentColor"
        />
        <path d="M21.38 9.75H12.75V20.1L21.38 9.75Z" fill="currentColor" />
        <path d="M11.25 20.1V9.75H2.62L11.25 20.1Z" fill="currentColor" />
        <path d="M7.54 8.25L10.16 3H5L2.38 8.25H7.54Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_3830_9686">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
